export enum MaskType {
  BankAccount = "BankAccount",
  BirthDate = "BirthDate",
  Card = "Card",
  ExpirationDate = "ExpirationDate",
  PhoneNumber = "PhoneNumber",
  PostalCode = "PostalCode",
}

// mask use

// mask used from https://github.com/benhurott/react-native-masked-text/blob/master/lib/masks/custom.mask.js
// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TODO: refactor this function
const toPattern = (value: string, mask: string) => {
  const translation: { [key: string]: (params: ToDo) => ToDo } = {
    "0": (val: string) => val.replace(/[^0-9]+/g, ""),
    "*": (val: string) => val,
  };
  let result = "";

  let maskCharIndex = 0;
  let valueCharIndex = 0;

  while (maskCharIndex < mask.length) {
    // if value is ended, break.
    if (valueCharIndex === value.length) {
      break;
    }

    const maskChar = mask[maskCharIndex] || "";
    const valueChar = value[valueCharIndex];

    // value equals mask, just set
    if (maskChar === valueChar) {
      result += maskChar;
      valueCharIndex += 1;
      maskCharIndex += 1;
      continue;
    }

    // apply translator if match
    const translationHandler = translation[maskChar];

    if (translationHandler) {
      const resolverValue = translationHandler(valueChar || "");

      if (resolverValue === "") {
        //valueChar replaced so don't add it to result, keep the mask at the same point and continue to next value char
        valueCharIndex += 1;
        continue;
      }

      if (resolverValue !== null) {
        result += resolverValue;
        valueCharIndex += 1;
      } else {
        result += maskChar;
      }
      maskCharIndex += 1;
      continue;
    }

    // not masked value, fixed char on mask
    result += maskChar;
    maskCharIndex += 1;
  }

  return result;
};

export const getMaskValue = ({
  mask,
  rawValue,
  countryCode,
}: { mask?: MaskType; rawValue: string; countryCode?: string }): string => {
  switch (mask) {
    case MaskType.PhoneNumber: {
      return rawValue.match(/.{1,3}/g)?.join(" ") ?? rawValue;
    }
    case MaskType.PostalCode:
      return toPattern(rawValue, countryCode === "NO" ? "0000" : "00-000");

    case MaskType.BankAccount:
      return toPattern(rawValue, "00 0000 0000 0000 0000 0000 0000");

    case MaskType.BirthDate:
      return toPattern(rawValue, "00/00/0000");

    case MaskType.Card:
      return toPattern(rawValue, "**** **** **** 0000");

    case MaskType.ExpirationDate:
      return toPattern(rawValue, "00/00");

    default:
      return rawValue;
  }
};
